<template lang="pug">
  div
    template(v-if="isLoaded")
      // Tabs Selector
      .white.pt-2
        v-tabs.tabs(left='', height='32', slider-color='primary'  v-model="active")

          //v-tab(@click="setTabID(0)")  History
          //v-tab-item(touchless)
          //  history-layout



          v-tab(@click="setTabID(0)")   Live Tracking


          v-tab(@click="setTabID(1)") Trip History


          v-tab(@click="setTabID(2)") Timeline


          v-tab(@click="setTabID(3)") Geofencing


        v-tabs-items(touchless  v-model="active")
          v-tab-item()
            live-layout
          v-tab-item()
            trip-layout
          v-tab-item()
            timeline-layout(:key="timelineKey")
          v-tab-item(touchless)
            geofence-layout(:key="timelineKey")



    template(v-else)
      .d-flex.align-center.justify-center(style="height:100%")
        v-progress-circular(indeterminate color="primary" :size="100")


</template>

<script>
import LiveLayout from "@/modules/maps/layouts/LiveLayout.vue";
import TimelineLayout from "@/modules/maps/layouts/TimelineLayout";
import TripLayout from "@/modules/maps/layouts/TripLayout";
import TempLayout from "@/modules/maps/layouts/TempLayout";
import SplitTest from "@/modules/maps/components/maps/SplitTest";
import GeofenceLayout from "@/modules/maps/layouts/GeofenceLayout";

export default {
  components: {
    LiveLayout,
    TimelineLayout,
    TripLayout,
    TempLayout,
    SplitTest,
    GeofenceLayout
  },

  data:()=>({
    isLoaded:false,
    timelineKey:0,
  }),


  computed: {
    active: {
      get: function () {
        let tabIndex = 0;
        if (this.$route.params.tabID != undefined) {
          tabIndex = parseInt(this.$route.params.tabID);
          tabIndex = tabIndex > 3 || tabIndex < 0 ? 0 : tabIndex;
        }
        return tabIndex;
      },

      set: function (value) {
        this.$route.params.tabID = value;

      }
    }
  },

  mounted() {
    if(this.$store.state.vehicles.all.length <= 1 || this.$store.state.vehicles.devices.device_data.length <= 1){
      console.log(`vehicles length ${this.$store.state.vehicles.all.length} device length ${this.$store.state.vehicles.devices.device_data.length}`)

      Promise.all([this.$store.dispatch("vehicles/loadAllItems"),this.$store.dispatch("vehicles/devices/loadAllDevices")]).then(()=>{
        this.isLoaded  = true;
      })
    }else{
      this.isLoaded = true;
    }

    // }

  },

  methods: {
    setTabID(value) {
      console.log(value)
      this.$store.commit("incrementMapKey");
      this.$store.commit("tracks/incrementMapKey");
      this.$router.push({name: "maps", params: {tabID: value}}).catch(()=>{});
      console.log(value);



        this.timelineKey += 1;

      // this.active = parseInt(value);
      // this.$route.params.tabID = parseInt(value);
      // this.$route.push({name:""})
    }
  }
};
</script>

<style scoped></style>
